import React from "react";
import PropTypes from "prop-types";

import WithGrid from "./WithGrid";
import Contents from "./Contents";

import { SectionContainer } from "../";

const SectionContainerJustText = ({
    text,
    isH1,
    isH2,
    isH4,
    subtext,
    button,
    bgColor,
    textColor,
    removePadding,
    removeTopBottomPadding,
    removeLeftRightPadding,
    removeBottomPadding,
    isHero,
    hasOffset
}) => {
    const isHeading1 = isH1 && !isH2 && !isH4;
    const isHeading2 = isH2 && !isH1 && !isH4;
    const isHeading4 = isH4 && !isH1 && !isH2;

    return (
        <SectionContainer
            bgColor={bgColor}
            textColor={textColor}
            removePadding={removePadding}
            removeTopBottomPadding={removeTopBottomPadding}
            removeLeftRightPadding={removeLeftRightPadding}
            removeBottomPadding={removeBottomPadding}
            isHero={isHero}
        >
            {hasOffset ? (
                <WithGrid
                    isHeading1={isHeading1}
                    isHeading2={isHeading2}
                    isHeading4={isHeading4}
                    text={text}
                    subtext={subtext}
                    button={button}
                />
            ) : (
                <Contents
                    isHeading1={isHeading1}
                    isHeading2={isHeading2}
                    isHeading4={isHeading4}
                    text={text}
                    subtext={subtext}
                    button={button}
                />
            )}
        </SectionContainer>
    );
};

SectionContainerJustText.propTypes = {
    text: PropTypes.string.isRequired,
    isH1: PropTypes.bool,
    isH2: PropTypes.bool,
    isH4: PropTypes.bool,
    subtext: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    button: PropTypes.object,
    bgColor: PropTypes.string,
    textColor: PropTypes.string,
    removePadding: PropTypes.bool,
    removeTopBottomPadding: PropTypes.bool,
    removeLeftRightPadding: PropTypes.bool,
    isHero: PropTypes.bool,
    hasOffset: PropTypes.bool
};

export { SectionContainerJustText };
